import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { getFaqs } from "../../services/productService";
import "./FAQSection.css";

function FAQSection() {

    const [faqs, setFaqs] = useState([]);
    const [activeFaq, setActiveFaq] = useState(null);

    useEffect(() => {
        loadFaqs();
    }, []);

    const loadFaqs = async () => {
        try {
            const response = await getFaqs();
            setFaqs(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const toggleFaq = (id) => {
        setActiveFaq(activeFaq === id ? null : id);
    };

    return (

        <section className="faq-section">

            <span className="faq-label">
                HELP CENTER
            </span>

            <h2 className="faq-title">
                Frequently Asked Questions
            </h2>

            <p className="faq-subtitle">
                Everything you need to know about FarmFox Premium Mithila Makhana.
            </p>

            <div className="faq-grid">

                {faqs.map((faq) => (

                    <div
                        key={faq.id}
                        className={`faq-card ${
                            activeFaq === faq.id ? "active" : ""
                        }`}
                    >

                        <button
                            className="faq-question"
                            onClick={() => toggleFaq(faq.id)}
                        >

                            <span>{faq.question}</span>

                            {activeFaq === faq.id
                                ? <ChevronUp size={20}/>
                                : <ChevronDown size={20}/>
                            }

                        </button>

                        <div className={`faq-answer ${
                            activeFaq === faq.id ? "show" : ""
                        }`}>

                            <p>
                                {faq.answer}
                            </p>

                        </div>

                    </div>

                ))}

            </div>

        </section>

    );

}

export default FAQSection;